export default "/_next/static/media/cxReturn.7792e21b6b3b88c6adc49cfaa702a9ef.mp4";